import React from 'react';
import useHandlePopoverClick from '../../hooks/useHandlePopoverClick';

const AddToCardActions = ({ cardId, card }) => {
    const { handlePopoverClick } = useHandlePopoverClick();

    // Determine which actions are not yet added/available
   
    const availableActions = [
        {
            id: 'popover-card-back-members-button',
            title: 'Members',
            icon: 'person_add',
            description: 'Add members to this card',
            onClick: (e) => handlePopoverClick(e, 'cardMemberesPopover', {
                isBack: true,
                backPopover: 'addToCardActions',
                cardId,
                card,
                isPopPositionChanged: false
            })
        },
        {
            id: 'popover-card-back-labels-button',
            title: 'Labels',
            icon: 'label',
            description: 'Add labels to this card',
            onClick: (e) => handlePopoverClick(e, 'addLabels', {
                isBack: true,
                backPopover: 'addToCardActions',
                cardId,
                card,
                isPopPositionChanged: false
            })
        },
        !card?.dueDate?.date && {
            id: 'popover-card-back-dates-button',
            title: 'Due Date',
            icon: 'schedule',
            description: 'Set a due date for this card',
            onClick: (e) => handlePopoverClick(e, 'addDueDate', {
                isBack: true,
                backPopover: 'addToCardActions',
                cardId,
                card,
                isPopPositionChanged: false
            })
        },
        {
            id: 'popover-card-back-checklist-button',
            title: 'Checklist',
            icon: 'checklist',
            description: 'Add a checklist to this card',
            onClick: (e) => handlePopoverClick(e, 'addChecklist', {
                isBack: true,
                backPopover: 'addToCardActions',
                cardId,
                card,
                isPopPositionChanged: false
            })
        },
        {
            id: 'popover-card-back-attachment-button',
            title: 'Attachment',
            icon: 'attachment',
            description: 'Add an attachment to this card',
            onClick: (e) => handlePopoverClick(e, 'attachment', {
                isBack: true,
                backPopover: 'addToCardActions',
                cardId,
                card,
                isPopPositionChanged: false
            })
        },
        {
            id: 'popover-card-back-custom-fields-button',
            title: 'Custom fields',
            icon: 'category',
            description: 'Set values for this card’s custom fields',
            onClick: (e) => handlePopoverClick(e, 'addCustomFields', {
                isBack: true,
                backPopover: 'addToCardActions',
                cardId,
                card,
                isPopPositionChanged: false
            })
        },
        {
            id: 'popover-card-back-cover-button',
            title: 'Cover',
            icon: 'image',
            description: 'Add a cover image to this card',
            onClick: (e) => handlePopoverClick(e, 'attachment', {
                type: 'COVER',
                isBack: true,
                backPopover: 'addToCardActions',
                cardId,
                card,
                isPopPositionChanged: false
            })
        }
    ].filter(Boolean);



    return (
        <div className="card-actions-popover">
            <div className="popover-header">
                <h3>Add To Card</h3>
            </div>
            <div className="popover-content">
                {availableActions.map((action) => (
                    <button
                        key={action.id}
                        className="add-action-item"
                        id={action.id}
                        onClick={action.onClick}
                        data-popover-trigger
                    >
                        <span className="material-symbols-outlined">{action.icon}</span>
                        <div className="action-info">
                            <span className="action-title">{action.title}</span>
                            <span className="action-description">{action.description}</span>
                        </div>
                    </button>
                ))}
            </div>

        </div>
    );
};

export default AddToCardActions;
